export default "__VITE_ASSET__CrO6JYUM__"